module.exports = __webpack_public_path__ + "img/fondo-banner-principal.30ebacf5.png";